// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__13mVb","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__3QhJK"};